export const NAMESPACE_AND_TIME_ADDED_INDEX = 'namespace-timeAdded';
export const RESILIENCE_DB_NAME = 'analytics-web-client';
export const RESILIENCE_STORE_NAME = 'analytics-resilience';
export const TIME_TO_PROCESS_AFTER_INDEX = 'timeToBeProcessedAfter';
export const TIME_ADDED_INDEX = 'timeAdded';
export const RETRY_INDEX = 'retryAttempts';
export const INDEXEDDB_TIMEOUT = 15000;
export let StoreType = /*#__PURE__*/function (StoreType) {
  StoreType["INDEXEDDB"] = "indexeddb";
  StoreType["MEMORY"] = "memory";
  return StoreType;
}({});

// Used to describe how the ResilienceDb should react when there is insufficient storage space.
export let GuardPolicy = /*#__PURE__*/function (GuardPolicy) {
  GuardPolicy["IGNORE"] = "ignore";
  GuardPolicy["ABANDON"] = "abandon";
  GuardPolicy["EVICT"] = "evict";
  return GuardPolicy;
}({});